namespace SPA
{
	export namespace Survey
	{

		export class Page
			extends ui.tab.TabHTMLPresentation
		{

			private	m_Object:						Wollmilch.TempSurvey.SurveyObject;
			private	m_ObjectBox:				ui.Box.Box;
			private	m_ContactdataBox:		ui.Box.Box;
			private	m_MitteilungenBox:	ui.Box.Box;
			private	m_PDFBox:						ui.Box.Box;
			private m_ProgressbarTitle:	JQuery<HTMLElement>;
			private m_Progressbar:			JQuery<HTMLElement>;

			private	m_SurveyInputs:			Array<ui.Form.BasicInputField<HTMLElement>>;
			// @ts-ignore
			private	m_ObjectDatas:			Array<ui.Form.BasicInputField<HTMLElement>>;

			// @ts-ignore
			private	m_ReportList:				SPA.gui.Listing<Wollmilch.TempSurvey.ReportDescription>;
			// @ts-ignore
			private	m_MessageList:			SPA.gui.Listing<Wollmilch.TempSurvey.SurveyMessage>;
			private OrderNo:						JQuery<HTMLElement>;

			public constructor( object: Wollmilch.TempSurvey.SurveyObject )
			{
				super();

				this.m_Object 					= object;
				this.m_ObjectBox 				= new ui.Box.Box();
				this.m_ContactdataBox 	= new ui.Box.Box();
				this.m_MitteilungenBox 	= new ui.Box.Box();
				this.m_PDFBox 					= new ui.Box.Box();
				this.m_ProgressbarTitle	= ui.$$.span();
				this.m_Progressbar 			= ui.$$.span();
				this.m_SurveyInputs 		= [];

				this.OrderNo = ui.$$.span();
			}

			public showMitteilungen()
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => {
					input.Base().addClass( baseclass.join( ' ' ) );
				};

				const t = new Wollmilch.AJAX(
					{
						data: {},
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								let obj: any;
								try
								{
									obj = Wollmilch.jsonize( text );
								}
								catch ( e )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'Survey.ERROR.no_info' ) ) ],
										context: 'warning',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
									},
									);
									return;
								}

								if ( !obj )
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'Aux.ERROR.JSON_PARSE' ) ) ],
										context: 'warning',
										timeout: Number(app.getConfigValue("ToastTimeout")),
										title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
									},
									);
									return;
								}

								if ( !obj.success && obj.error )
								{
									app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'Survey.ERROR.no_info' ) ) ],
											context: 'warning',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 3, app.getMessage( 'Survey.ERROR.title' ) ) ],
										},
									);
									return;
								}

								if ( obj.data )
								{
									// ProgressBar
									let Progression	= 0;
									let Text				= app.getMessage( 'Survey.PAGE.STATUS.open' );
									let Context			= 'danger';

									if ( obj.data.Survey && obj.data.Survey.State )
									{
										if ( obj.data.Survey.Storned )
										{
											Progression = 100;
											Text 				= app.getMessage( 'Survey.PAGE.STATUS.storned' );
											Context			= 'danger';
										}
										else
										{
											switch ( obj.data.Survey.State )
											{
												case '-1':
												{
													if ( obj.data.Survey.Status === 10 )
													{
														Progression = 10;
														Text 				= app.getMessage( 'Survey.PAGE.STATUS.pending' );
														Context			= 'info';
														break;
													}
													else
													{
														Progression	= 100;
														Text 				= app.getMessage( 'Survey.PAGE.STATUS.error' );
														Context			= 'danger';
														break;
													}
												}
												case '4':
												{
													Progression	= 15;
													Text 				= app.getMessage( 'Survey.PAGE.STATUS.queued' );
													Context			= 'info';
													break;
												}
												case '3':
												{
													Progression = 20;
													Text 				= app.getMessage( 'Survey.PAGE.STATUS.transmitted' );
													Context			= 'primary';
													break;
												}
												case '2':
												{
													Progression = 40;
													Text 				= app.getMessage( 'Survey.PAGE.STATUS.atWork' );
													Context			= 'primary';
													break;
												}
												case '1':
												{
													Progression = 70;
													Text 				= app.getMessage( 'Survey.PAGE.STATUS.scheduled' );
													Context			= 'warning';
													break;
												}
												case '0':
												{
													Progression	= 100;
													Text 				= app.getMessage( 'Survey.PAGE.STATUS.completed' );
													Context			= 'success';
													break;
												}
											}
										}
									}

									this.m_ProgressbarTitle.append( ui.$$.text( Text ) ).addClass( 'text-' + Context );

									this.OrderNo.append( ( obj.data.OrderRef )
										? obj.data.OrderRef.toString()
										: app.getMessage( 'Survey.GENERAL.noValue' ),
									);

									this.m_Progressbar.append( new ProgressBar(
									{
										animated: true,
										context: Context,
										max: 100,
										min: 0,
										name: 'status',
										striped: true,
										text: '',
										value: Progression,
									} ).getElement(),
									);

									// Message
									if ( obj.data.Survey.Messages )
									{
										if ( obj.data.Survey.Messages.length === 0 )
										{
											return;
										}
										this.m_MitteilungenBox.clearTitle();
										this.m_MitteilungenBox.addTitle( app.getMessage( 'Survey.LABEL.TITLE.news' ) );
										this.m_MitteilungenBox.rebuild().appendTo( this.Root() );

										this.m_MessageList = new SPA.gui.Listing<Wollmilch.TempSurvey.SurveyMessage>(
											new SPA.Survey.data.SurveyMessageTableDataModel(
											{
												header: true,
												headerEnd: true,
												style:
												{
													condense: true,
													hover: true,
													stripes: true,
												},
											}),
											10,
											( list: SPA.gui.Listing<Wollmilch.TempSurvey.SurveyMessage> ): void =>
											{
												if ( obj )
												{
													list.Content().Data( obj.data.Survey.Messages );
													list.Content().rebuild();
												}
											},
										);
										this.m_MessageList.showPagination( false );
										this.m_MessageList.rebuild( ui.$$.div().appendTo( this.m_MitteilungenBox.Root() ) );

										const fg = ui.$$.div().appendTo( this.m_MitteilungenBox.Root() );
									}

									// PDF
									if ( obj.data.Reports.length > 0 )
									{
										this.m_PDFBox.clearTitle();
										this.m_PDFBox.addTitle( app.getMessage( 'Survey.LABEL.TITLE.pdf' ) );
										this.m_PDFBox.rebuild().appendTo( this.Root() );

										this.m_ReportList = new SPA.gui.Listing<Wollmilch.TempSurvey.ReportDescription>(
											new SPA.Survey.data.SurveyPDFTableDataModel(
											{
												header: true,
												headerEnd: true,
												style:
												{
													condense: true,
													hover: true,
													stripes: true,
												},
											}),
											10,
											( list: SPA.gui.Listing<Wollmilch.TempSurvey.ReportDescription> ): void =>
											{
												if ( obj )
												{
													list.Content().Data( obj.data.Reports );
													list.Content().rebuild();
												}
											},
										);
										this.m_ReportList.showPagination( false );
										this.m_ReportList.rebuild( ui.$$.div().appendTo( this.m_PDFBox.Root() ) );

										const fg = ui.$$.div().appendTo( this.m_PDFBox.Root() );
									}
								}
							},
						},
						url: 'object/getstatus/' + encodeURIComponent( btoa( this.m_Object.ObjectNumber ) ),
					},
					Wollmilch.AJAXCallbase_e.TEMPSURVEY,
				).send();
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): Page
			{
				super.rebuild( root );

				this.showMitteilungen();

				this.m_ObjectBox.rebuild().appendTo( this.Root() );
				this.m_ContactdataBox.rebuild().appendTo( this.Root() );

				this.showContactData();
				this.showData();

				if ( this.m_Entry )
				{
					this.m_Entry.DeactivateReloadSpin();
				}

				return this;
			}

			private showData()
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => {
					input.Base().addClass( baseclass.join( ' ' ) );
				};

				const ProductName = ( idx: number ): string =>
				{
					let id = 'Product.';
					switch ( idx )
					{
						case 1:		id += 'TempSurvey.InsideOutside'; break;
						case 2:		id += 'TempSurvey.Outside'; break;

						default:	id += 'Unrecognizable'; break;
					}

					return id;
				};

				this.m_ObjectBox.addTitle( app.getMessage( ProductName( this.m_Object.Order.Product ) )
					+ ': ' + this.m_Object.ObjectNumber,
				);

				new SPA.Navigation.BreadCrumb( this.m_Object.ObjectNumber ).rebuild( this.m_ObjectBox );

				this.m_ObjectBox.append( ui.$$.div().addClass( 'form-group col-xs-12 col-md-12' )
					.append( ui.$$.h( 3, this.m_Object.Object.Address.display ).attr( 'style', 'display: inline' ) )
					.append( ui.$$.text(
							this.m_Object.Order.DevArea ? ' (' + app.getMessage( 'Survey.LABEL.OBJECT.devarea' ) + ')' : ' ',
						),
					),
				);

				// linke Spalte
				let tab = new Table(
					{
						bordered: false,
						column_number: 2,
						hover: false,
						striped: false,
					},
				);

				tab.createDataRow( -1, [app.getMessage( 'Survey.LABEL.OBJECT.ref_no' ), this.OrderNo] );
				tab.createDataRow( -1, [app.getMessage( 'Survey.LABEL.OBJECT.forecast_to_the' ),
					new Date( this.m_Object.Order.Forecast ).pattern( 'd.m.Y' ) ],
				);
				tab.createDataRow( -1, [app.getMessage( 'Survey.LABEL.OBJECT.unitcount' ),
					this.m_Object.Order.UnitCount.toString() ],
				);

				const panelLeft = new Panel(
					{
						body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
						header: [ ui.$$.span().append( app.getMessage( 'Survey.GENERAL.order' ) ) ],
						header_sticky: true,
					},
				).getElement();

				// mittlere Spalte
				tab = new Table(
					{
						bordered: false,
						column_number: 2,
						hover: false,
						striped: false,
					},
				);

				tab.createDataRow( -1, [app.getMessage( 'Survey.LABEL.OBJECT.devarea'),
					(this.m_Object.Order.DevArea)
						? ui.$$.span().addClass('fa fa-check text-success')
						: ui.$$.span().addClass('fa fa-close text-danger') ],
				);
				tab.createDataRow( -1, [app.getMessage( 'Survey.PAGE.BUILDING_TYPE.label' ),
					app.getSpanMessage( 'Survey.NEW.BUILDING_KIND.' + this.m_Object.Order.BuildingType )
						.attr('title', app.getMessage( 'Survey.PAGE.BUILDING_TYPE.' + this.m_Object.Order.BuildingType )) ],
				);
				tab.createDataRow( -1, [app.getMessage( 'Survey.LABEL.OBJECT.grannyflat' ),
					(this.m_Object.Order.GrannyFlat)
						? ui.$$.span().addClass('fa fa-check text-success')
						: ui.$$.span().addClass('fa fa-close text-danger') ],
				);
				tab.createDataRow( -1, [app.getMessage( 'Survey.NEW.TENANCY_RATE.tenancy' ), this.m_Object.Order.Tenancy ] );

				const panelMiddle = new Panel(
				{
					body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
					header: [ ui.$$.span().append( app.getMessage( 'Survey.LABEL.TITLE.object' ) ) ],
					header_sticky: true,
				},
				).getElement();

				// rechte Spalte
				tab = new Table(
				{
					bordered: false,
					column_number: 1,
					hover: false,
					striped: false,
				},
				);

				const OrderInfo = ui.$$.div().append( ui.$$.text( this.m_Object.Order.Info ) )
					.attr( 'style', 'height: 5.2em; max-height: 5.2em; overflow-y: auto; margin: 0px; border: 1px solid #dddddd' );

				tab.createDataRow( -1, [ this.m_ProgressbarTitle ] );
				tab.createDataRow( -1, [ this.m_Progressbar ] );
				tab.createDataRow( -1, [ OrderInfo ] );

				const panelRight = new Panel(
				{
					body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
					header: [ ui.$$.span().append( app.getMessage( 'Survey.LABEL.OBJECT.info' ) ) ],
					header_sticky: true,
				},
				).getElement();

				this.m_ObjectBox.Root().append(ui.$$.div()).addClass( 'clearfix' )
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelLeft ) )
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelMiddle ) )
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelRight ) );
			}

			private showContactData()
			{
				this.m_ContactdataBox.addTitle( app.getMessage( 'Survey.LABEL.TITLE.addresses' ) );

				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => {
					input.Base().addClass( baseclass.join( ' ' ) );
				};

				// linke Spalte
				let tab = new Table(
				{
					bordered: false,
					column_number: 2,
					hover: false,
					striped: false,
				},
				);

				tab.createDataRow( -1, [ app.getMessage( 'Survey.LABEL.PERSON.name' ),
					this.m_Object.Stakeholder.name ],
				);
				tab.createDataRow( -1, [ app.getMessage( 'Survey.LABEL.PERSON.address' ),
					this.m_Object.Stakeholder.Address.display ],
				);

				const panelLeft = new Panel(
				{
					body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
					header: [ ui.$$.span().append( app.getMessage( 'Survey.LABEL.TITLE.customer' ) ) ],
					header_sticky: true,
				},
				).getElement();

				// mittlere Spalte
				tab = new Table(
				{
					bordered: false,
					column_number: 3,
					hover: false,
					striped: false,
				},
				);

				const phonetype = ui.$$.span();
				switch ( this.m_Object.Contact.type )
				{
					case 'home':
					{
						phonetype.addClass('fa fa-home')
							.attr('title', app.getMessage('Survey.LABEL.PERSON.PHONE.' + this.m_Object.Contact.type) );
						break;
					}
					case 'mobile':
					{
						phonetype.addClass('fa fa-mobile')
							.attr('title', app.getMessage('Survey.LABEL.PERSON.PHONE.' + this.m_Object.Contact.type) );
						break;
					}
					case 'office':
					{
						phonetype.addClass('fa fa-building')
							.attr('title', app.getMessage('Survey.LABEL.PERSON.PHONE.' + this.m_Object.Contact.type) );
						break;
					}
					default:
					{
						phonetype.addClass('fa fa-phone');
						break;
					}
				}

				tab.createDataRow( -1,
					[ app.getMessage( 'Survey.LABEL.PERSON.surname' ), '', this.m_Object.Contact.name ],
				);
				tab.createDataRow( -1,
					[ app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' )
						+ ' (' + app.getMessage( 'Survey.LABEL.PERSON.PHONE.' + this.m_Object.Contact.reachability ) + ')',
						phonetype, this.m_Object.Contact.phone,
					],
				);
				tab.createDataRow( -1,
					[ app.getMessage( 'Survey.LABEL.PERSON.email' ),
						'',
						ui.$$.a().append( this.m_Object.Contact.email ).attr( 'href', 'mailto:' + this.m_Object.Contact.email ),
					],
				);

				const panelMiddle = new Panel(
				{
					body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
					header: [ ui.$$.span().append( app.getMessage( 'Survey.LABEL.TITLE.contact' ) ) ],
					header_sticky: true,
				},
				).getElement();

				// rechte Spalte
				tab = new Table(
				{
					bordered: false,
					column_number: 2,
					hover: false,
					striped: false,
				},
				);

				tab.createDataRow( -1, [ app.getMessage( 'Survey.LABEL.PERSON.surname' ), this.m_Object.Tenant.name ] );
				tab.createDataRow( -1, [ app.getMessage( 'Survey.LABEL.PERSON.PHONE.title' ), this.m_Object.Tenant.phone] );
				tab.createDataRow( -1, [ app.getMessage( 'Survey.LABEL.PERSON.email' ),
					ui.$$.a().append( this.m_Object.Tenant.email ).attr( 'href', 'mailto:' + this.m_Object.Tenant.email ) ],
				);

				const panelRight = new Panel(
				{
					body: [ $(tab.getTable()).addClass( 'table-borderless' ) ],
					header: [ ui.$$.span().append( app.getMessage( 'Survey.LABEL.TITLE.tenant' ) ) ],
					header_sticky: true,
				},
				).getElement();

				this.m_ContactdataBox.Root().append( ui.$$.div() ).addClass( 'clearfix' )
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelLeft ) )
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelMiddle )
						.attr('style', ( this.m_Object.Order.Product === 2) ? 'opacity:0.2' : 'opacity:1' ),
					)
					.append( ui.$$.div().addClass( 'col-xs-12 col-md-4').append( panelRight )
						.attr('style', ( this.m_Object.Order.Product === 2 ) ? 'opacity:0.2' : 'opacity:1' ),
					);
			}

		}

	}
}
